/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_See_AllInputs */

const en_us2_search_see_all = /** @type {(inputs: Search_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all exercises`)
};

const pt_br2_search_see_all = /** @type {(inputs: Search_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos os exercícios`)
};

const es_419_search_see_all = /** @type {(inputs: Search_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos los ejercicios`)
};

const pt_pt2_search_see_all = /** @type {(inputs: Search_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos os exercícios`)
};

const fr_fr2_search_see_all = /** @type {(inputs: Search_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir tous les exercices`)
};

const de_de2_search_see_all = /** @type {(inputs: Search_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Übungen ansehen`)
};

const it_it2_search_see_all = /** @type {(inputs: Search_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi tutti gli esercizi`)
};

/**
* | output |
* | --- |
* | "See all exercises" |
*
* @param {Search_See_AllInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_see_all = /** @type {((inputs?: Search_See_AllInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_See_AllInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_see_all(inputs)
	if (locale === "es-419") return es_419_search_see_all(inputs)
	if (locale === "pt-PT") return pt_pt2_search_see_all(inputs)
	if (locale === "fr-FR") return fr_fr2_search_see_all(inputs)
	if (locale === "de-DE") return de_de2_search_see_all(inputs)
	if (locale === "it-IT") return it_it2_search_see_all(inputs)
	return en_us2_search_see_all(inputs)
});
export { search_see_all as "search.see_all" }